import * as z from "zod";
import { ShopperAgentConfigVersionMetaSchema } from "./shopper-agent-config-version-meta";

/** Publishes the draft: old published version archives, draft goes live. */
export const publishShopperAgentConfig = {
  name: "publishShopperAgentConfig" as const,
  input: z.object({}),
  output: z.object({ version: ShopperAgentConfigVersionMetaSchema }),
};
